// src/pages/ResumeDetails.js
//
// Página de detalhe do currículo (Fase G.1.3).
// Pública para currículos com `visibility === 'public'`. O dono do
// currículo sempre vê o próprio (mesmo se privado).
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import useProtectedRoute from '../hooks/useProtectedRoute';
import Menu from '../components/Menu';
import Footer from '../components/Footer';
import Button from '../components/Button/Button';
import ResumeView from '../components/ResumeView';

const ResumeDetails = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const isLoggedIn = useProtectedRoute();
  const [resume, setResume] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentUid, setCurrentUid] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUid(user ? user.uid : null);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!userId) return;
    (async () => {
      try {
        const snap = await getDoc(doc(db, 'resumes', userId));
        if (snap.exists()) {
          setResume({ id: snap.id, ...snap.data() });
        } else {
          setResume(null);
        }
      } catch (err) {
        console.error('Erro ao carregar currículo:', err);
      } finally {
        setLoading(false);
      }
    })();
  }, [userId]);

  if (!isLoggedIn) return null;

  const isOwner = currentUid && currentUid === userId;
  const canView = resume && (resume.visibility === 'public' || isOwner);

  return (
    <>
      <Menu isLoggedIn={isLoggedIn} />
      <div className="bg-gray-50 min-h-screen py-8 print:bg-white print:py-0">
        <div className="max-w-3xl mx-auto px-4 mb-4 flex justify-between items-center print:hidden">
          <button onClick={() => navigate(-1)} className="text-sm text-gray-700 hover:underline">
            &lt; Voltar
          </button>
          <div className="flex gap-2">
            {isOwner && (
              <Link to="/meu-curriculo">
                <Button text="Editar meu currículo" variant="outline" />
              </Link>
            )}
            {canView && (
              <Button text="Imprimir / Salvar em PDF" variant="transparent" onClick={() => window.print()} />
            )}
          </div>
        </div>

        {loading ? (
          <p className="text-center text-gray-600">Carregando...</p>
        ) : !resume ? (
          <p className="text-center text-gray-600">Currículo não encontrado.</p>
        ) : !canView ? (
          <p className="text-center text-gray-600">Este currículo está configurado como privado pelo seu autor.</p>
        ) : (
          <ResumeView resume={resume} />
        )}
      </div>
      <Footer />
    </>
  );
};

export default ResumeDetails;
